var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Catalog",
    _vm._g(
      {
        attrs: {
          title: "Услуги самозанятых",
          "name-label": "Название услуги",
          "submit-error": "Укажите название услуги.",
          "fetch-data": _vm.fetchData,
          "put-data": _vm.putData,
          "post-data": _vm.postData,
          "exact-id": _vm.createId
        }
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b893f59", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b893f59","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkServices/WorkService.vue
// module id = null
// module chunks = 